// store/index.js
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import foodsReducer from "./foodsSlice";
import mealsReducer from "./mealsSlice";
import todayReducer from "./todaySlice";
import personalReducer from "./personalSlice";
import historyReducer from "./historySlice";

import authReducer from "./authSlice";
import { scheduleIDBWrite } from "../sync/syncService"; // ✅

const appReducer = combineReducers({
  foods: foodsReducer,
  meals: mealsReducer,
  today: todayReducer,
  personal: personalReducer,
  history: historyReducer,
  auth: authReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "auth/logout") {
    state = undefined;
  }
  return appReducer(state, action);
};

export const store = configureStore({ reducer: rootReducer });

// ✅ replaced old subscribe — scheduleIDBWrite has the isRehydrated guard
store.subscribe(() => {
  scheduleIDBWrite(store);
});